import { MOBILE } from '@/src/constants/deviceTypes'
import { Box } from '@mui/material'
import AirlineFilterShimmer from './airlineFilterShimmer'
import DateCarouselShimmer from './dateCarouselShimmer'
import FlightCardShimmer from './flightCardShimmer'
import SrpTipBannerWrapper from '@/src/components/desktop/srp/srpTipBanner'

const SrpLoadingShimmer = () => (
    <Box sx={{ p: 2 }}>
        <SrpTipBannerWrapper />
        <DateCarouselShimmer />
        {/* Header shimmer */}
        <Box sx={{ mb: 2 }}>
            <AirlineFilterShimmer deviceType={MOBILE} />
        </Box>
        {/* Flight cards shimmer */}
        {[...Array(5)].map((_, i) => (
            <FlightCardShimmer key={i} />
        ))}
    </Box>
)

export default SrpLoadingShimmer
